module.exports = __webpack_public_path__ + "static/media/4-Hl-Barbara-klein.42523ebf.jpg";